import React from 'react';
import _ from 'lodash';
import toast from 'react-hot-toast';
import { Box, Stack, Button, Card, CardContent, CardHeader, Typography, Chip, Fab, Tooltip, IconButton, Checkbox } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import UndoIcon from '@mui/icons-material/Undo';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import { SmallFormDateField } from '../../../../../components/small-fields/SmallFormDateField';
import { formatDate, formatDateTime } from '../../../../../services/functions';
import { useApplication } from '../../ApplicationsContext';
import PreviewQuestionnaire from './PreviewQuestionnaire/PreviewQuestionnaire';
import ImageModal from '../../../generics/components/ImageModal';
import defaultImage from '../default.png';
import { useSelector } from 'react-redux';
import { useParameterizedQuery } from 'react-fetching-library';
import { downloadQuestionnaireFileAction } from '../../../../../services/request';

export default function EmployeeData ({ formik, fileInputRef, createQuestionnaire, handleChangeImage, handlePhotoChange, loading, preview, isDefaultPhoto }) {
  const { choices, rowData } = useApplication();
  const { seasonIdentifier } = useSelector((state => state.app));
  const [open, setOpen] = React.useState(false);
  const [openImage, setOpenImage] = React.useState(false);
  const { query, loading: downloadQuestionnaireLoading } = useParameterizedQuery(downloadQuestionnaireFileAction);

  const handleDownloadQuestionnaire = async id => {
    console.log(id);
    const { payload, error, loading } = await query(id);

    if (!error) {
      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = `Kwestionariusz - ${rowData.name} ${rowData.surname}`;
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };


  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" spacing={2}>
          <Button
            type="button"
            variant="contained"
            onClick={() => createQuestionnaire(rowData.id)}
            disabled={rowData.questionnaire_state !== 'not_sent' || ['REJ', 'FOU'].includes(formik.values.state) || seasonIdentifier == 'l_23_rekrutacja'}
          >
            {rowData.questionnaire_state !== 'not_sent' ? 'Kwestionariusz wysłany' : 'Wyślij kwestionariusz'}
          </Button>
          {rowData.questionnaire_state === 'sent'
            ? <Tooltip title="Oczekiwanie na wypełnienie kwestionariusza" color="warning"><HourglassEmptyIcon /></Tooltip>
            : rowData.questionnaire_state === 'filled'
              ? <Stack direction="row" alignItems="center">
                <Tooltip title="Zobacz wypełniony kwestionariusz" color="primary">
                  <IconButton color="primary" onClick={() => setOpen(true)}>
                    <RemoveRedEyeIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Pobierz kwestionariusz" color="primary">
                  <IconButton color="primary" disabled={downloadQuestionnaireLoading} onClick={() => handleDownloadQuestionnaire(rowData.id)}>
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
              : null
          }
        </Stack>
        <SmallFormTextField
          select
          label="Typ"
          name="employee_type"
          placeholder="Typ"
          value={formik.values.employee_type}
          onChange={formik.handleChange}
          sx={{ width: '20%' }}
          options={choices.employee_type}
        />
      </Stack>
      <Stack sx={{ mt: 2 }} direction="row" spacing={2}>
        <Card sx={{ width: '200px', height: '250px' }}>
          <CardContent>
            <img
              src={preview}
              style={{ objectFit: 'cover', width: '150px', height: '150px', margin: '0 auto', border: '2px solid #00AB55', borderRadius: '16px', cursor: 'zoom-in' }}
              onClick={() => setOpenImage(true)}
            >
            </img>
            <Stack style={{ marginTop: '10px' }} direction="row" justifyContent="space-between">
              <Button variant="contained" component="label" disabled={loading}>
                  Zmień
                <input type="file" accept="image/*" hidden ref={fileInputRef} onChange={handleChangeImage}/>
              </Button>
              {
                formik.values.is_photo_changed || formik.values.is_photo_deleted
                  ? <Fab size="small" color="secondary" onClick={() => handlePhotoChange(false)} disabled={loading}>
                    <UndoIcon />
                  </Fab>
                  : <Fab size="small" color="error" disabled={preview === defaultImage || isDefaultPhoto || loading} onClick={() => handlePhotoChange(true)}>
                    <DeleteIcon />
                  </Fab>
              }
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <Stack spacing={2}>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Imię</Typography>
                <SmallFormTextField
                  name="name"
                  placeholder="Imię"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  helperText={formik.errors.name}
                  error={formik.errors.name && formik.touched.name}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Nazwisko</Typography>
                <SmallFormTextField
                  name="surname"
                  placeholder="Naziwsko"
                  value={formik.values.surname}
                  onChange={formik.handleChange}
                  helperText={formik.errors.surname}
                  error={formik.errors.surname && formik.touched.surname}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Data urodzenia</Typography>
                <SmallFormDateField
                  name="birth_date"
                  value={formik.values.birth_date}
                  onChange={val => formik.setFieldValue('birth_date', formatDate(val))}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Miejsce urodzenia</Typography>
                <SmallFormTextField
                  name="place_of_birth"
                  placeholder="Miejsce urodzenia"
                  value={formik.values.place_of_birth}
                  onChange={formik.handleChange}
                  helperText={formik.errors.place_of_birth}
                  error={formik.errors.place_of_birth && formik.touched.place_of_birth}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Email</Typography>
                <SmallFormTextField
                  name="correspondence_email"
                  placeholder="Email"
                  value={formik.values.correspondence_email}
                  onChange={formik.handleChange}
                  helperText={formik.errors.correspondence_email}
                  error={formik.errors.correspondence_email && formik.touched.correspondence_email}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Telefon</Typography>
                <SmallFormTextField
                  name="phone"
                  placeholder="Telefon"
                  value={formik.values.phone}
                  onChange={formik.handleChange}
                  helperText={formik.errors.phone}
                  error={formik.errors.phone && formik.touched.phone}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>PESEL</Typography>
                <SmallFormTextField
                  name="pesel"
                  placeholder="PESEL"
                  value={formik.values.pesel}
                  onChange={formik.handleChange}
                  helperText={formik.errors.pesel}
                  error={formik.errors.pesel && formik.touched.pesel}
                  sx={{ width: '75%' }}
                />
              </Stack>
            </Stack>
          </CardContent>
        </Card>
        <Card sx={{ flex: 1 }}>
          <CardContent>
            <Stack spacing={2}>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Ulica</Typography>
                <SmallFormTextField
                  name="address.street"
                  placeholder="Ulica"
                  value={formik.values.address.street}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Nr domu/mieszkania</Typography>
                <SmallFormTextField
                  name="address.house"
                  placeholder="Nr domu/mieszkania"
                  value={formik.values.address.house}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Miasto</Typography>
                <SmallFormTextField
                  name="address.city"
                  placeholder="Miasto"
                  value={formik.values.address.city}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Kod pocztowy</Typography>
                <SmallFormTextField
                  name="address.postal_code"
                  placeholder="Kod pocztowy"
                  value={formik.values.address.postal_code}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Nazwa Firmy</Typography>
                <SmallFormTextField
                  name="company_name"
                  placeholder="Nazwa firmy"
                  value={formik.values.company_name}
                  onChange={formik.handleChange}
                  helperText={formik.errors.company_name}
                  error={formik.errors.company_name && formik.touched.company_name}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>NIP</Typography>
                <SmallFormTextField
                  name="nip"
                  placeholder="NIP"
                  value={formik.values.nip}
                  onChange={formik.handleChange}
                  helperText={formik.errors.nip}
                  error={formik.errors.nip && formik.touched.nip}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Numer konta</Typography>
                <SmallFormTextField
                  name="account_number"
                  placeholder="Numer konta"
                  value={formik.values.account_number}
                  onChange={formik.handleChange}
                  helperText={formik.errors.account_number}
                  error={formik.errors.account_number && formik.touched.account_number}
                  sx={{ width: '75%' }}
                />
              </Stack>
            </Stack>
          </CardContent>
        </Card>
      </Stack>
      <Stack sx={{ mt: 2 }}>
        <Card>
          <CardContent>
            <Stack spacing={2}>
              <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Notatki</Typography>
                <SmallFormTextField
                  name="notes"
                  value={formik.values.notes}
                  onChange={formik.handleChange}
                  placeholder="Notatki"
                  sx={{ width: '75%' }}
                  multiline={true}
                  rows={4}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Funkcja</Typography>
                <SmallFormTextField
                  // disabled={rowData ? rowData.agreement_number !== '' : false}
                  name="function_type"
                  select
                  placeholder="Funkcja"
                  value={formik.values.function_type}
                  onChange={formik.handleChange}
                  options={choices.function_type}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Wykształcenie</Typography>
                <SmallFormTextField
                  name="education"
                  select
                  placeholder="Wykształcenie"
                  value={formik.values.education}
                  onChange={formik.handleChange}
                  options={choices.education}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Obecny status zatrudnienia</Typography>
                <SmallFormTextField
                  name="current_employee_status"
                  select
                  placeholder="Obecny status zatrudnienia"
                  value={formik.values.current_employee_status}
                  onChange={formik.handleChange}
                  options={choices.current_employee_status}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Doświadczenie w pracy na obozach lub zielonych szkołach</Typography>
                <SmallFormTextField
                  name="experience"
                  select
                  placeholder="Doświadczenie w pracy na obozach lub zielonych szkołach"
                  value={formik.values.experience}
                  onChange={formik.handleChange}
                  options={choices.experience}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Jakie doświadczenie?</Typography>
                <SmallFormTextField
                  name="what_experience"
                  placeholder="Jakie doświadczenie?"
                  value={formik.values.what_experience}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Gdzie?</Typography>
                <SmallFormTextField
                  name="where_experience"
                  placeholder="Gdzie?"
                  value={formik.values.where_experience}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>W jakiej roli?</Typography>
                <SmallFormTextField
                  name="role_experience"
                  placeholder="W jakiej roli?"
                  value={formik.values.role_experience}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              {rowData.season_identifer === 'l_23_rekrutacja'
                ? <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                  <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Preferowana grupa wiekowa</Typography>
                  <SmallFormTextField
                    name="preferred_age_group"
                    select
                    placeholder="Preferowana grupa wiekowa"
                    value={formik.values.preferred_age_group}
                    onChange={formik.handleChange}
                    options={choices.prefered_age}
                    sx={{ width: '75%' }}
                  />
                </Stack>
                : <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                  <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Preferowane grupy wiekowe</Typography>
                  <SmallFormTextField
                    name="preferred_age_group_multiple"
                    select
                    multiple
                    placeholder="Preferowane grupy wiekowe"
                    value={formik.values.preferred_age_group_multiple}
                    onChange={formik.handleChange}
                    options={choices.prefered_age}
                    sx={{ width: '75%' }}
                    renderValue={selected => (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map(value => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                  />
                </Stack>}
              <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Uprawnienia pedagogiczne</Typography>
                <SmallFormTextField
                  name="pedagogical_qualifications"
                  select
                  multiple
                  placeholder="Uprawnienia pedagogiczne"
                  value={formik.values.pedagogical_qualifications}
                  onChange={formik.handleChange}
                  options={choices.pedagogical_qualifications}
                  sx={{ width: '75%' }}
                  renderValue={selected => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map(value => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Inne uprawnienia pedagogiczne</Typography>
                <SmallFormTextField
                  name="other_pedagogical_qualifications"
                  placeholder="Inne uprawnienia pedagogiczne"
                  value={formik.values.other_pedagogical_qualifications}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Pozostałe uprawnienia</Typography>
                <SmallFormTextField
                  name="additional_qualifications"
                  select
                  multiple
                  placeholder="Pozostałe uprawnienia"
                  value={formik.values.additional_qualifications}
                  onChange={formik.handleChange}
                  options={choices.additional_qualifications}
                  sx={{ width: '75%' }}
                  renderValue={selected => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map(value => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Inne uprawnienia</Typography>
                <SmallFormTextField
                  name="other_additional_qualifications"
                  placeholder="Inne uprawnienia"
                  value={formik.values.other_additional_qualifications}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              {/* 7 - instruktor 12 - pomocnik instruktora */}
              {formik.values.function_type == 7 || formik.values.function_type == 12
                ? <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                  <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Sport instruktora</Typography>
                  <SmallFormTextField
                    name="instructor_sport_type"
                    placeholder="Sport instruktora"
                    value={formik.values.instructor_sport_type}
                    onChange={formik.handleChange}
                    sx={{ width: '75%' }}
                  />
                </Stack>
                : null}
              {/* 7 - instruktor 12 - pomocnik instruktora */}
              {formik.values.function_type == 7 || formik.values.function_type == 12
                ? <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                  <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Specjalizacja instruktora</Typography>
                  <SmallFormTextField
                    name="instructor_specialization"
                    placeholder="Specjalizacja na umowie"
                    value={formik.values.instructor_specialization}
                    onChange={formik.handleChange}
                    sx={{ width: '75%' }}
                  />
                </Stack>
                : null}
              <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Zakres umiejętności</Typography>
                <SmallFormTextField
                  name="range_of_skills"
                  select
                  multiple
                  placeholder="Zakres umiejętności"
                  value={formik.values.range_of_skills}
                  onChange={formik.handleChange}
                  options={choices.range_of_skills}
                  sx={{ width: '75%' }}
                  renderValue={selected => (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {selected.map(value => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Inne umiejętności</Typography>
                <SmallFormTextField
                  name="other_skills"
                  placeholder="Inne umiejętności"
                  value={formik.values.other_skills}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Źródło oferty</Typography>
                <SmallFormTextField
                  name="source_of_offer"
                  select
                  placeholder="Źródło oferty"
                  value={formik.values.source_of_offer}
                  onChange={formik.handleChange}
                  options={choices.source_of_offer}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Polecony przez</Typography>
                <SmallFormTextField
                  name="recommended_by"
                  placeholder="Polecony przez"
                  value={formik.values.recommended_by}
                  onChange={formik.handleChange}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Rozmiar odzieży firmowej</Typography>
                <SmallFormTextField
                  name="company_clothing_size"
                  select
                  placeholder="Rozmiar odzieży firmowej"
                  value={formik.values.company_clothing_size}
                  onChange={formik.handleChange}
                  options={choices.company_clothing_size}
                  sx={{ width: '75%' }}
                />
              </Stack>
              <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Informacje o sobie</Typography>
                <SmallFormTextField
                  name="about_me"
                  value={formik.values.about_me}
                  onChange={formik.handleChange}
                  placeholder="Informacje o sobie"
                  sx={{ width: '75%' }}
                  multiline={true}
                  rows={4}
                />
              </Stack>
              <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Dodatkowe uwagi</Typography>
                <SmallFormTextField
                  name="additional_comments"
                  value={formik.values.additional_comments}
                  onChange={formik.handleChange}
                  placeholder="Dodatkowe uwagi"
                  sx={{ width: '75%' }}
                  multiline={true}
                  rows={4}
                />
              </Stack>
              <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Dieta</Typography>
                <SmallFormTextField
                  name="diet"
                  value={formik.values.diet}
                  onChange={formik.handleChange}
                  placeholder="dieta"
                  sx={{ width: '75%' }}
                  multiline={true}
                  rows={4}
                />
              </Stack>
              <Stack direction="row" alignItems="left" justifyContent="left" spacing={1} mb={2}>
                <Typography variant="subtitle2" flex="1 1 25%">Transport własny</Typography>
                <Box sx={{ flex: '1 1 80%' }}>
                  <Checkbox
                    id="own_transport"
                    name="own_transport"
                    checked={formik.values.own_transport}
                    onChange={formik.handleChange} />
                </Box>
              </Stack>
              <Stack direction="row" alignItems="left" justifyContent="left" spacing={1} mb={2}>
                <Typography variant="subtitle2" flex="1 1 25%">Trzeba odebrać z dworca</Typography>
                <Box sx={{ flex: '1 1 80%' }}>
                  <Checkbox
                    id="transport_has_to_be_picked_up"
                    name="transport_has_to_be_picked_up"
                    checked={formik.values.transport_has_to_be_picked_up}
                    onChange={formik.handleChange} />
                </Box>
              </Stack>

              { formik.values.transport_has_to_be_picked_up
                ? <Stack direction="row" alignItems="flex-start" justifyContent="left" spacing={1}>
                  <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Transport informacje</Typography>
                  <SmallFormTextField
                    name="transport_info"
                    value={formik.values.transport_info}
                    onChange={formik.handleChange}
                    placeholder="Transport informacje"
                    sx={{ width: '75%' }}
                    multiline={true}
                    rows={4}
                  />
                </Stack>
                : null}
              <Stack direction="row" alignItems="left" justifyContent="left" spacing={1} mb={2}>
                <Typography variant="subtitle2" flex="1 1 25%">Sprawdzony w rejestrze</Typography>
                <Box sx={{ flex: '1 1 80%' }}>
                  <Checkbox
                    id="register_checked"
                    name="register_checked"
                    checked={formik.values.register_checked}
                    onChange={formik.handleChange} />
                </Box>
              </Stack>
            </Stack>
          </CardContent>
        </Card>
        {/* Zgody */}
        {formik.values.consents.length > 0
          ? <Card>
            <CardHeader title="Zgody"/>
            <CardContent>
              <Stack direction="column" spacing={2}>
                {formik.values.consents.map((consent, index) => (
                  <Stack
                    key={consent.type}
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    mb={1}
                  >
                    <Typography variant="subtitle2" flex="1 1 35%">
                      {consent.type_display}
                    </Typography>
                    <Box sx={{ flex: '1 1 25%' }}>
                      <Checkbox
                        id={`consents.${index}.accepted`}
                        name={`consents.${index}.accepted`}
                        checked={consent.accepted}
                        onChange={formik.handleChange}
                        disabled={true}
                      />
                    </Box>
                    <Typography variant="subtitle2" flex="1 1 20%">
                      Ważna od:
                    </Typography>
                    <Typography variant="" flex="1 1 25%">
                      {formatDateTime(consent.accepted_at)}
                    </Typography>
                    <Typography variant="subtitle2" flex="1 1 20%">
                      Ważna do:
                    </Typography>
                    <Typography variant="" flex="1 1 25%">
                      {formatDateTime(consent.expires_at)}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </CardContent>
          </Card>
          : null}
      </Stack>
      {open ? <PreviewQuestionnaire handleClose={() => setOpen(false)}/> : null}
      <ImageModal open={openImage} handleClose={() => setOpenImage(false)} src={preview}/>
    </>
  );
}
